<template>
  <Loader v-if="loadingFilter" />
  <div class="flex justify-content-center flex-wrap">
    <Button :class="`m-2 btn-filter flex justify-content-center ${type.selected ? 'selected' : ''}`" v-for="type in types_pp" :key="type.name" @click="getListSubentro(type)">
      Visualizza {{ type.name.toUpperCase() }}
    </Button>
  </div>
  <div class="table-container" style="overflow-x: auto" v-if="currentData">
    <div
      v-if="showSuccessAlert"
      class="p-col-12 p-d-flex p-jc-center"
      style="
        margin-top: 20px;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 9999;
      ">
      <div class="p-alert p-component p-alert-success" role="alert" style="
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
          border-radius: 4px;
          background-color: #52c41a;
          color: #fff;
          padding: 10px 20px;
        ">
        <div class="p-alert-content">Preventivo aggiunto con successo!</div>
      </div>
    </div>
    <div v-if="showSuccessAlert2" class="p-col-12 p-d-flex p-jc-center" style="
        margin-top: 20px;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 9999;
      ">
      <div class="p-alert p-component p-alert-success-allegato" role="alert" style="
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
          border-radius: 4px;
          background-color: #52c41a;
          color: #fff;
          padding: 10px 20px;
        ">
        <div class="p-alert-content">Allegato caricato con successo!</div>
      </div>
    </div>
   
    <DataTable v-else v-model:filters="filters" :value="filteredSubentro" responsiveLayout="scroll" dataKey="id" editMode="cell" filterDisplay="row" :globalFilterFields="['code', 'stato_corrispondente']" :paginator="true" :rows="50" paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown" :rowsPerPageOptions="[10, 20, 50, 100, 500]" currentPageReportTemplate="{first} a {last} di {totalRecords}" :rowClass="rowClass">
      <template #header>
        <div class="flex flex-wrap align-items-center justify-content-between gap-2">
          <div class="flex">
            <div class="flex align-items-center">
              <Checkbox v-model="has_selectedRows" :binary="true" @update:modelValue="selectAllRows" class="m-3"/>
              <label>{{ has_selectedRows ? "Deseleziona tutti" : "Seleziona tutti"
              }}</label>
            </div>
            <InputText v-model="searchTerm" placeholder="Cerca..." class="p-inputtext p-component ml-4 mt-4 mb-4" style="width: 300px"/>
          </div>
          <div>
            <Button v-if="filteredSubentro.length > 0" label="Esporta File" icon="pi pi-download" class="p-button-secondary" @click="exportToExcel" style=" margin-right: 10px;" />
            <Button v-if="isVisibleBtnDownloadSubentro" class="m-2 p-button-rounded p-button-raised" icon="pi pi-download" label="Scarica subentri" @click="downloadFileSubentro"/>
          </div>
        </div>
        <hr style="margin: 20px 0; border-top: 0.5px solid #ccc;" />
        <div>
          <label>Seleziona altri stati pratica da cercare</label>
          <div class="flex flex-wrap align-items-center">
            <MultiSelect v-model="searchedStatus.new" :options="types_stato_pratica" optionLabel="stato" placeholder="Seleziona altri stati pratica da cercare" class="mt-2"/>
            <Button v-if="isVisibleBtnSearchedStatus" icon="pi pi-search" @click="setSearchedStatus" class="ml-2"/>
          </div>
        </div>
        <hr/>
        <div style="display: flex; align-items: center">
          <div v-if="user && ['admin','pratiche'].includes(user.profile.name)">
            <Dropdown v-model="massiveSelectedStatus" :options="statiMassivi" optionLabel="stato" placeholder="Seleziona Stato" class="mb-4"/>
          </div>
          <Button label="Applica Stato" class="ml-1 mb-4" @click="applyMassiveStatusChange" :disabled="!(user && ['admin','pratiche'].includes(user.profile.name))"/>
        </div>
      </template>
      <template #empty>
        Non ci sono pratiche di subentro 
      </template>
      <Column headerStyle="width: 3rem">
        <template #body="{ data }">
          <Checkbox v-if="data.canSelect" v-model="data.selected" :binary="true" @update:modelValue="inSelectedRows(data)"/>
        </template>
      </Column>
      <!-- <div style="display: flex; align-items: center">
        <div v-if="user && ['admin','pratiche'].includes(user.profile.name)">
          <Dropdown v-model="massiveSelectedStatus" :options="timelineData" optionLabel="stato"
            placeholder="Seleziona Stato" class="mb-4" />
        </div>
        <Button
          label="Applica Stato"
          class="ml-2 mb-4"
          @click="applyMassiveStatusChange"
          :disabled="!(user && ['admin','pratiche'].includes(user.profile.name))"
        />
        <Button
        :icon="isActive ? 'pi pi-eye-slash' : 'pi pi-eye'"
        :class="['small-button mb-4 ml-2', { 'active-button': isActive }]"
        @click="rimuoviFiltroStato"
      />
      </div> -->
      <Column header="Storico">
        <template #body="{ data }">
          <Button icon="pi pi-info-circle" @click="openInfoDialog(data)"/>
        </template>
      </Column>
      <Column field="id" header="Id Pratica" sortable></Column>
      <Column field="matrice_id" header="Id matrice" sortable></Column>
      <Column field="data_creazione" header="Data Creazione" sortable>
        <template #body="{data}">
          {{ moment(data.data_creazione).format('DD/MM/Y HH:mm:ss') }}
        </template>
      </Column>
      <Column field="dataValidazione" header="Data Validazione" sortable>
        <template #body="{data}">
          {{ moment(data.dataValidazione).format('DD/MM/Y HH:mm:ss') }}
        </template>
      </Column>
      <Column field="dataFirma" header="Data Firma" sortable>
        <template #body="{data}">
          {{ moment(data.dataFirma).format('DD/MM/Y HH:mm:ss') }}
        </template>
      </Column>
      <Column field="denominazione" header="Ragione Sociale" style="width: 150px">
        <template #body="{ data }">
          <p @click="handleButtonClick3(data.clientid)" class="text-primary cursor-pointer">
            {{ data.denominazione }}
          </p>
        </template>
      </Column>
      <Column field="cf" header="Codice Fiscale"></Column>
      <Column field="piva" header="Partita Iva"></Column>
      <Column field="referente" header="Referente"></Column>
      <Column field="code" header="Fornitura">
        <template #filter="{ filterModel, filterCallback }">
          <InputText v-model="filterModel.value" type="text" @input="filterCallback()" style="min-width: 8rem" placeholder="Ricerca fornitura"/>
        </template>
      </Column>
      <Column field="matricola" header="Matricola"></Column>
      <Column field="protocollo" header="PROTOCOLLO SII" editMode="cell">
        <template #editor="{ data, field }">
          <input type="text" v-model="data[field]" @blur="saveEdit(data.id, field, data[field])"
            @keydown.enter.prevent="saveEdit(data.id, field, data[field])" class="p-inputtext p-component" />
        </template>
      </Column>
      <Column field="udd" header="UDD" editMode="cell">
        <template #editor="{ data, field }">
          <input type="text" v-model="data[field]" @blur="saveEdit(data.id, field, data[field])"
            @keydown.enter.prevent="saveEdit(data.id, field, data[field])" class="p-inputtext p-component" />
        </template>
      </Column>
      <Column field="tipoFornitura" header="Tipologia Uso"></Column>
      <Column field="nameResidente" header="Residente"></Column>
      <Column field="cell" header="Telefono"></Column>
      <!-- <Column field="indirizzo_completo" header="Indirizzo"></Column> -->
      <Column field="toponimo" header="Toponimo"></Column>
      <Column field="indirizzo" header="Indirizzo"></Column>
      <Column field="civico" header="Civico"></Column>
      <Column field="cap" header="Cap"></Column>
      <Column field="comune" header="Comune"></Column>
      <Column field="code_provincia" header="Provincia"></Column>
      <Column field="istat" header="Istat"></Column>
      <Column field="email" header="Email"></Column>
      <Column field="stato_corrispondente" header="Stato" sortable :showFilterMenu="false" :style="{ width: '14rem' }">
        <template #body="{ data }">
          <div class="flex flex-column align-items-center">
            {{ data.stato_corrispondente }}
            <div v-if="data.cod_type_stato_pratica == 10">
              {{ data.nota }} - {{ data.cod_errore_sii }} - {{ data.motivazione_errore_sii }}
            </div>
            <!-- <div v-if="data.cod_type_stato_pratica == 1 && data.filename != null">
              <Button icon="pi pi-trash" label="Ripristina pratica" class="p-button-danger" @click="resetPratica(data)"/>
            </div> -->
          </div>
        </template>
        <template #filter="{ filterModel, filterCallback }">
          <Dropdown v-model="filterModel.value" @change="filterCallback()" :options="types_stato_pratica"
            placeholder="Seleziona stato" style="min-width: 10rem" optionLabel="stato" optionValue="stato">
            <template #option="slotProps">
              {{ slotProps.option.stato }}
            </template>
          </Dropdown>
        </template>
      </Column>
      <Column field="nota" header="Nota Stato"></Column>
      <Column field="precheck_description" header="Dettaglio Esito Precheck"></Column>
      <Column header="File">
        <template #body="{ data }">
          <Button icon="pi pi-folder" @click="openFilesDialog(data.id, data.matrice_id)" />
        </template>
      </Column>
      <Column v-if="currentType === 'gas'" header="Richiesta appuntamento" style="width: 250px">
        <template #body="{ data }">
          <span
            v-if="data.appuntamento"
            :title="data.appuntamento"
            style="max-width: 200px; display: inline-block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
          >
            {{ data.appuntamento }}
          </span>
          <span v-else class="text-500">Nessuna richiesta</span>
        </template>
      </Column>
      <Column v-if="currentType === 'gas'" header="Azioni" style="width: 100px">
        <template #body="{ data }">
          <AppuntamentoPratica :pratica="data" tipo-pratica="subentro" :supply-code="data.code" />
        </template>
      </Column>
    </DataTable>
    <Dialog v-model:visible="filesDialogVisible" modal header="File Associati Alla Pratica" :style="{ width: '50rem' }"
      :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
      <div class="files-list">
        <ul>
          <li v-for="file in selectedFiles" :key="file.matrice_documenti_id" class="file-link"
            @click="downloadPdf(selectedMatriceId, file.filename)">
            {{ file.filename }}
          </li>
        </ul>
        <Button label="Scarica tutti i file" @click="downloadZip(selectedMatriceId)" icon="pi pi-download" />
      </div>
    </Dialog>
    <Dialog v-model:visible="dialoginfo" modal header="Stato Pratiche" :style="{ width: '80rem' }"
      :breakpoints="{ '1199px': '75vw', '575px': '90vw' }" class="custom-dialog stato-dialog">
      <Loader v-if="dialogLoading" />
      <div v-else class="dialog-content stato-layout">
        <div class="timeline-container">
          <Timeline v-if="timelineData && timelineData.length > 0" :value="timelineData" :key="timelineKey" class="m-2 ml-0">
            <template #marker="slotProps">
              <span
                class="flex align-items-center justify-content-center border-circle z-1 shadow-1"
                :style="{
                  backgroundColor: slotProps.item.color,
                  width: '1.5rem',
                  height: '1.5rem',
                }"
              >
              </span>
              <div
                class="p-timeline-event-connector"
                :style="{
                  backgroundColor: slotProps.item.color_connector,
                  width: '3px',
                }"
              ></div>
            </template>
            <template #connector>
              <div></div>
            </template>
            <template #content="slotProps">
              <span :class="[{strong: selectedpratica.cod_type_stato_pratica == slotProps.item.id}]">{{ slotProps.item.stato }}</span>
              <SottostatiTimeline
                :voci="slotProps.item.sottostati"
                :corrente="selectedpratica && selectedpratica.cod_type_stato_pratica"
              />
            </template>
          </Timeline>
        </div>
                <div class="data-tables-container stato-pannello">
          <div class="stato-scheda" v-if="selectedpratica">
            <div class="stato-scheda__voce">
              <span>Pratica</span>
              <strong>Subentro</strong>
            </div>
            <div class="stato-scheda__voce">
              <span>Cliente</span>
              <strong>{{
                selectedpratica.denominazione
                || [selectedpratica.nomerappresentante, selectedpratica.cognomerappresentante].filter(Boolean).join(" ")
                || [selectedpratica.NomeCliente, selectedpratica.CognomeCliente].filter(Boolean).join(" ")
                || selectedpratica.intestatario
                || "-"
              }}</strong>
            </div>
            <div class="stato-scheda__voce">
              <span>POD/PDR</span>
              <strong>{{ selectedpratica.code || "-" }}</strong>
            </div>
            <div class="stato-scheda__voce">
              <span>Stato attuale</span>
              <strong>{{ selectedpratica.stato_corrispondente || selectedpratica.stato_pratica || "-" }}</strong>
            </div>
          </div>
          <section class="stato-blocco stato-modulo" v-if="selectedpratica">
            <h3>Aggiorna stato</h3>
            <label class="stato-campo">
              <span>Stato</span>
              <Dropdown
                v-model="selectedpratica.selectedStato"
                :options="vedeSoloPreventivo(user) ? statiSoloPreventivo : newStati"
                optionLabel="stato"
                @change="changePraticaStatus(selectedpratica)"
              />
            </label>
            <label class="stato-privato">
              <input
                type="checkbox"
                v-model="selectedpratica.privato"
                @change="changePraticaStatus(selectedpratica)"
                :true-value="1"
                :false-value="0"
                :disabled="isPrivateAutomaticallyManaged"
              />
              Privato
            </label>
            <NotaInvioDocumentazione v-model="selectedpratica.nota" :pratica="selectedpratica">
              <template #default="{ openEditor, isDocumentationState }">
                <Button
                  v-if="isDocumentationState"
                  type="button"
                  label="Inserisci documentazione"
                  icon="pi pi-file-edit"
                  @click="openEditor"
                />
                <label v-else class="stato-campo">
                  <span>Nota</span>
                  <textarea
                    class="stato-nota"
                    :value="selectedpratica.nota || ''"
                    placeholder="Inserisci la nota"
                    @input="selectedpratica.nota = $event.target.value"
                  />
                </label>
              </template>
            </NotaInvioDocumentazione>
            <button
              type="button"
              class="styled-button-Nota"
              :class="{
                'styled-button-Nota--invio': faseInvioStato === 'invio',
                'styled-button-Nota--ok': faseInvioStato === 'inviato',
              }"
              :disabled="faseInvioStato === 'invio'"
              @click="inviaStatoAnimato(selectedpratica)"
            >
              <span v-if="faseInvioStato === 'invio'" class="invio-stato__spinner" aria-hidden="true"></span>
              <span v-else-if="faseInvioStato === 'inviato'" class="invio-stato__check" aria-hidden="true">✓</span>
              {{ faseInvioStato === 'invio' ? 'Invio…' : faseInvioStato === 'inviato' ? 'Inviato' : 'Invia' }}
            </button>
          </section>
          <form @submit.prevent="onSubmitFileUpload" class="form-container stato-blocco stato-file">
            <h3>File</h3>
            <div class="stato-file__riga">
              <span class="stato-file__nome">Allegato</span>
              <div class="button-group flex">
              <div class="col-6">
                <label for="fileInput1" class="custom-file-upload" id="fileLabel1">
                  Carica Allegato
                </label>
                <input type="file" id="fileInput1" @change="handleUploadPratiche($event)" class="file-input2"/>
              </div>
              <div class="col-6">
                <Button v-if="selectedpratica !== null" @click="downloadAllegatoPratica(selectedpratica.code,selectedpratica.id)" class="custom-file-upload" label="Scarica Allegato"/>
              </div>
            </div>
            </div>
            <div class="stato-file__riga">
              <span class="stato-file__nome">Preventivo</span>
              <div class="button-group">
              <label 
                v-if="user && ['admin','pratiche'].includes(user.profile.name)"
                for="fileInput2" 
                class="custom-file-upload" 
                id="fileLabel2"
              >
                <i class="fas fa-cloud-upload-alt"></i> Carica Preventivo
              </label>
              <input 
                v-if="user && ['admin','pratiche'].includes(user.profile.name)"
                type="file" 
                id="fileInput2" 
                @change="handleFileChange($event)" 
                class="file-input" 
              />
              <button 
                v-if="selectedpratica !== null" 
                @click="downloadPreventivoPratica(selectedpratica.id,selectedpratica.code)" 
                class="custom-file-download"
              >
                <i class="pi pi-download"></i> Scarica Preventivo
              </button>
            </div>
            </div>
            <PreventivoFirmatoBox
              :stato="selectedpratica && selectedpratica.selectedStato"
              :pratica-id="selectedpratica && selectedpratica.id"
              type-file="Subentro"
              @file="impostaFilePreventivoFirmato"
            />
            <div class="p-alert-content" id="error-alert" style="display: none">
              Non ci sono file da scaricare.
            </div>
          </form>
          <section class="stato-blocco stato-storico">
            <h3>Storico note</h3>
            <DataTable :value="selectedpratica.states" :paginator="true" :rows="3">
            <Column field="data_nota" header="Data"></Column>
            <Column field="stato_corrispondente" header="Stato"></Column>
            <Column field="nota" header="Nota"></Column>
            <Column field="is_private" header="Privato">
              <template #body="{ data }">
                <span v-if="data.is_private === 0" class="text-color-secondary">No</span>
                <span v-else-if="data.is_private === 1">SI</span>
              </template>
            </Column>
          </DataTable>
          </section>
          <section class="stato-blocco stato-importo">
            <h3>Importo</h3>
            <div v-if="preventivoEsistente" class="preventivo-esistente">
            <p><strong>Preventivo già inserito:</strong> € {{ preventivoEsistente.importo.toFixed(2) }}</p>
          </div>
          <button v-else @click="openPreventivo" class="styled-button-Nota-Preventivo">
            Genera Preventivo
          </button>
          </section>
        </div>
      </div>
    </Dialog>
    <Dialog v-model:visible="preventivoDialog" modal header="Genera Preventivo" :style="{ width: '50rem' }">
      <div class="p-fluid">
        <div class="p-field p-grid mb-3">
          <label class="p-col-12"><b>Importo (€):</b></label>
          <div class="p-col-12 mt-2">
            <InputNumber v-model="importoPreventivo" mode="currency" currency="EUR" locale="it-IT" />
          </div>
        </div>

        <div class="p-field p-grid mb-2">
          <label class="p-col-12"><b>Dati Cliente:</b></label>
          <div class="p-col-12">
            <div class="cliente-info">
              <p><b>Ragione Sociale:</b> {{ selectedpratica?.denominazione || '-' }}</p>
              <p><b>Codice Fiscale:</b> {{ selectedpratica?.cf || '-' }}</p>
              <p><b>Partita IVA:</b> {{ selectedpratica?.piva || '-' }}</p>
              <p><b>Telefono:</b> {{ selectedpratica?.cell || '-' }}</p>
              <p><b>Email:</b> {{ selectedpratica?.email || '-' }}</p>
              <p><b>Indirizzo:</b> {{ selectedpratica?.indirizzo_completo || '-' }}</p>
              <p><b>Codice POD/PDR:</b> {{ selectedpratica?.code || '-' }}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="dialog-footer" style="text-align: right; margin-top: 20px;">
        <Button label="Annulla" icon="pi pi-times" class="p-button-text" @click="preventivoDialog = false" />
        <Button label="Genera" icon="pi pi-check" class="p-button-success" @click="generaPreventivo" />
      </div>
    </Dialog>
    <Dialog 
      v-model:visible="dialogCompletamento" 
      modal 
      header="Data Completamento" 
      :style="{ width: '30rem' }"
    >
      <div class="p-fluid">
        <div class="p-field">
          <label for="dataCompletamento"><b>Data Completamento:</b></label>
          <div style="margin-top: 10px;">
            <Calendar 
              v-model="dataCompletamento" 
              :showIcon="true" 
              dateFormat="dd/mm/yy" 
              class="w-full"
              id="dataCompletamento"
            />
          </div>
        </div>
      </div>
      <div class="dialog-footer" style="text-align: right; margin-top: 20px;">
        <Button label="Annulla" icon="pi pi-times" class="p-button-text" @click="dialogCompletamento = false" />
        <Button label="Conferma" icon="pi pi-check" class="p-button-success" @click="confermaCompletamento" />
      </div>
    </Dialog>
    <Dialog v-model:visible="isDownloadedFilePratica" modal :style="{ width: '80rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }" class="custom-dialog">
      <div class="col-12">
        <p class="mb-4 flex justify-content-center">
          File generato: <strong>{{ filenameSubentro }}</strong>
        </p>
        <div class="mb-4 flex justify-content-center">
          <br />
          <div>
            <label for="id_pratica">Inserisci l'Id della richiesta</label><br />
            <InputMask id="id_pratica" v-model="id_pratica" mask="9999999" />
          </div>
        </div>
        <div class="flex justify-content-center">
          <Button icon="pi pi-link" label="Salva l'ID della richiesta" @click="saveIdPratica" :disabled="id_pratica == ''"/>
        </div>
      </div>
    </Dialog>
  </div>
</template>
<script>
import { ref, onMounted, watch, computed } from "vue";
import moment from "moment";
import Service from "@/services/ask-pratiche/gestione-pratiche";
import Loader from "@/components/Loader.vue";
import * as XLSX from "xlsx";
import { useToast } from "primevue/usetoast";
import { FilterMatchMode } from "primevue/api";
import NotaInvioDocumentazione from "./NotaInvioDocumentazione.vue";
import PreventivoFirmatoBox from "./PreventivoFirmatoBox.vue";
import SottostatiTimeline from "./SottostatiTimeline.vue";
import {
  idPreventivoFirmato,
  isPreventivoFirmato,
  annidaPreventivoFirmato,
  ordinaStati,
  preparaPreventivoFirmato,
  statiBasePreventivo,
  statoTimelineRaggiunto,
  statoTimelineSuperato,
  vedeSoloPreventivo,
} from "@/services/ask-pratiche/preventivoFirmato";
import AppuntamentoPratica from "./AppuntamentoPratica.vue";
export default {
  components: {
    AppuntamentoPratica,
    Loader,
    NotaInvioDocumentazione,
    PreventivoFirmatoBox,
    SottostatiTimeline,
  },
  props: {
    data: Array,
    stati: Array,
  },
  setup(props) {
    const user = ref(null);
    const loader = ref(false);
    const dialogLoading = ref(false);
    const loading = ref(false);
    const service = new Service();
    const toast = useToast();
    const Subentro = ref([]);
    const filteredSubentro = ref([]);
    const loadingFilter = ref(false);
    const showFilterButton = ref(false);
    let filtroStatoAttivo = true;
    const newFilesView = ref({});
    const cod_pod = ref("");
    const rappid = ref("");
    const clientid = ref("");
    const timelineData = ref([]);
    const newStati = ref([]);
    const statiSoloPreventivo = computed(() => statiBasePreventivo(newStati.value));
    const dialoginfo = ref(false);
    const showSuccessAlert = ref(false);
    const showSuccessAlert2 = ref(false);
    const isActive = ref(false);
    const selectedpratica = ref({
      code: "",
      cod_pratica: "",
      privato: 1,
      value: {
        file: null,
      },
      coloreStatoPratica: "default",
    });
    const selectedRows = ref([]);
    const massiveSelectedStatus = ref(null);
    const expandedRows = ref([]);
    const activeFilterType = ref("");
    const searchTerm = ref("");
    const searchCode = ref("");
    const statiDisponibili = ref([]);
    const timelineKey = ref(0);
    const currentRecordIndex = ref(null);
    const dialogVisible = ref(false);
    const nuovaPratica = ref({
      statoPratica: "",
      dataInserimento: "",
      infoContatore: "",
      telefono: "",
      udd: "",
      codicePratica: "",
    });
    const preventivoDialog = ref(false);
    const importoPreventivo = ref(null);
    const preventivoData = ref({
      cod_cliente: null,
      cod_pratica: null, 
      importo: null,
      stato: 0,
      type_pratica: 'Subentro',
      creation_time: null
    });
    const activeFilter = ref('');
    const currentDate = new Date();
    const defaultDate = ref(
      currentDate.toLocaleDateString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
      })
    );
    const types_stato_pratica = ref([]);
    const filesDialogVisible = ref(false);
    const selectedFiles = ref([]);
    const selectedMatriceId = ref(null);
    const isVisibleBtnDownloadSubentro = computed(() => {
      return selectedRows.value.length;
    });
    const types_pp = ref([
      {name:'pod', selected: false, loaded: false, data: [], type: 'ee'},
      {name:'pdr', selected: false, loaded: false, data: [], type: 'gas'}
    ])
    const currentData = ref()
    const currentItem = ref([])
    const currentType = ref()
    const preventivoEsistente = ref(null);
    const dialogCompletamento = ref(false);
    const dataCompletamento = ref(null);
    const praticaInCompletamento = ref(null);
    const searchedStatus = ref({
      old: [],
      new: []
    })
    const getListSubentro = async (item = null, status = [null], forceReload = false) => {            
      currentItem.value = item
      if (!item.loaded || forceReload) {
        let index = types_pp.value.findIndex(type => type.name == item.name)
        types_pp.value.forEach((el, i)=>{
          el.selected = i == index ? true : false
        })
        loadingFilter.value = true;
        await service.getListSubentroType(item.type, status)
        .then(res => {
          if (status[0] == null) {
            if (forceReload) searchedStatus.value = {old: [], new: []}
            item.data = res
            currentData.value = res
            fetchUploadedFiles(res);              
          }else{
            item.data.push(...res)
            currentData.value.push(...res)
          }
        })
        .finally(()=>{
          applyFilter(item.data)
          filterData()
          item.loaded = true
          loadingFilter.value = false;
        })
      }else{
        currentData.value = item.data
        applyFilter(item.data)
      }
      let index = types_pp.value.findIndex(type => type.name == item.name)
        types_pp.value.forEach((el, i)=>{
          el.selected = i == index ? true : false
        })
      currentType.value = item.type
    };
    watch(searchTerm, () => {
      filterData()
    });
    const filters = ref({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      code: { value: null, matchMode: FilterMatchMode.CONTAINS },
      stato_corrispondente: { value: null, matchMode: FilterMatchMode.EQUALS },
    });
    onMounted(() => {
      types_stato_pratica.value = ordinaStati(props.stati);
      newStati.value = [...types_stato_pratica.value]
      const storedUser = localStorage.getItem("user");
      if (storedUser) {
        user.value = JSON.parse(atob(storedUser)).user[0];
      }
      filterData();
      Promise.all([
        applyFilter(props.data)
      ]);
    });
    const setSearchedStatus = async () => {
      let old_status = searchedStatus.value.old.map((state => state.id))
      let new_status = searchedStatus.value.new.map((state => state.id))

      const old_set = new Set(old_status)
      const new_set = new Set(new_status)
      const elementiDaCercare = new_status.filter(valore => !old_set.has(valore));
      const elementiDaRimuovere = old_status.filter(valore => !new_set.has(valore));

      filteredSubentro.value = [...filteredSubentro.value.filter(data => !(elementiDaRimuovere.includes(data.cod_type_stato_pratica)))]

      if (!currentData.value) currentData.value = []
      currentData.value = [...currentData.value.filter(data => !(elementiDaRimuovere.includes(data.cod_type_stato_pratica)))]
      
      currentItem.value.data = [...currentItem.value.data.filter(data => !(elementiDaRimuovere.includes(data.cod_type_stato_pratica)))]

      currentItem.value.loaded = false
      await getListSubentro(currentItem.value, elementiDaCercare)

      searchedStatus.value.old = [...searchedStatus.value.new]
    }
    const isVisibleBtnSearchedStatus = computed(()=>{
      return JSON.stringify(searchedStatus.value.old) != JSON.stringify(searchedStatus.value.new) && searchedStatus.value.new.length != 0
    })
    const filterData = () => {
      if (searchTerm.value) {
        filteredSubentro.value = Subentro.value.filter((item) =>
          Object.values(item)
            .join(" ")
            .toLowerCase()
            .includes(searchTerm.value.toLowerCase())
        );
      } else {
        filteredSubentro.value = [...Subentro.value];
      }
    };
    const fetchUploadedFiles = async (data) => {
      try {
        const filesResponse = data;
        const existingFiles = Subentro.value;
        filesResponse.forEach((file) => {
          const existingFileIndex = existingFiles.findIndex(
            (existing) => existing.id === file.id
          );
          if (existingFileIndex !== -1) {
            existingFiles[existingFileIndex] = {
              ...existingFiles[existingFileIndex],
              ...file,
              created_at: moment(file.data).format("YYYY-MM-DD HH:mm:ss"),
              isTimelineVisible: false,
              uniqueId: existingFiles[existingFileIndex].uniqueId,
            };
          } else {
            existingFiles.push({
              ...file,
              created_at: moment(file.data).format("YYYY-MM-DD HH:mm:ss"),
              isTimelineVisible: false,
              uniqueId: existingFiles.length + 1,
            });
          }
        });
        Subentro.value = existingFiles;
        filteredSubentro.value = existingFiles.filter(
          (data) => data.stato_corrispondente !== "completamento"
        );
        loader.value = false;
        newFilesView.value = {};
        // await Promise.all(
        //   filesResponse.map(async (file) => {
        //     const fileCaricamentoResponse = await service.getFileCaricamento(
        //       file.matrice_id
        //     );
        //     newFilesView.value[file.id] = fileCaricamentoResponse.items || [];
        //   })
        // );
      } catch (error) {
        console.error("Errore durante il recupero dei file:", error);
        loader.value = false;
      }
    };
    const statiMassivi = computed(() =>
      (newStati.value || []).filter((stato) => !isPreventivoFirmato(stato))
    );
    const impostaFilePreventivoFirmato = (file) => {
      if (selectedpratica.value) {
        selectedpratica.value.filePreventivoFirmato = file;
      }
    };

    const applyMassiveStatusChange = async () => {
      if (isPreventivoFirmato(massiveSelectedStatus.value)) {
        toast.add({
          severity: "error",
          summary: "File obbligatorio",
          detail: "Il preventivo firmato va caricato sulla singola pratica.",
          life: 4000,
        });
        return;
      }
      if (!massiveSelectedStatus.value || selectedRows.value.length === 0) {
        return;
      }
      for (let i = 0; i < selectedRows.value.length; i++) {
        const row = selectedRows.value[i];
        const plainRow = JSON.parse(JSON.stringify(row));
        plainRow.selectedStato = massiveSelectedStatus.value;
        service.syncPrivateByNote(plainRow);
        plainRow.tipologia = plainRow.tipologia || "Subentro";
        await inviaNota(plainRow, "Subentro");
      }
      selectedRows.value = [];
      massiveSelectedStatus.value = null;
      await fetchUploadedFiles();
    };
    const saveEdit = async (id, field, value) => {
      try {
        await service.updateUddOrProtocolloSII(id, field, value);
        const recordIndex = Subentro.value.findIndex((item) => item.id === id);
        if (recordIndex !== -1) {
          Subentro.value[recordIndex] = {
            ...Subentro.value[recordIndex],
            [field]: value,
          };
          filteredSubentro.value = [...Subentro.value];
        }
      } catch (error) {
        console.error("Errore durante il salvataggio:", error);
      }
    };
    const downloadPdf = async (matrice_id, name) => {
      loading.value = true;
      await service.downloadPdf(matrice_id, name).finally(() => {
        loading.value = false;
      });
    };
    const downloadZip = async (matrice_id) => {
      loading.value = true;
      await service.downloadZip(matrice_id).finally(() => {
        loading.value = false;
      });
    };
    const applyFilter = async (data) => {
      try {
        filteredSubentro.value = data;
        filteredSubentro.value.forEach((item) => {
          let stato = null;
          let canSelect = true;
          if (item.cod_type_stato_pratica) {
            stato = types_stato_pratica.value.find((type) => type.id == item.cod_type_stato_pratica).stato;
            canSelect = false;
          }
          item.stato_corrispondente = stato;
          item.canSelect = canSelect;
        });
        Subentro.value = [...filteredSubentro.value]
        loadingFilter.value = false;
        showFilterButton.value = true;
      } catch (error) {
        console.error("Errore durante il recupero dei file:", error);
        loadingFilter.value = false;
      }
    };
    const rimuoviFiltroStato = () => {
      filtroStatoAttivo = !filtroStatoAttivo;
      if (filtroStatoAttivo) {
        filteredSubentro.value = filteredSubentro.value.filter(
          (data) => data.stato_corrispondente !== "completamento"
        );
      } else {
        applyCurrentFilter();
      }
      isActive.value = !isActive.value;
    };
    const filterByCode = () => {
      const code = searchCode.value.toLowerCase();
      let filteredFiles = Subentro.value;
      if (activeFilterType.value === "filtroPod") {
        filteredFiles = filteredFiles.filter((file) =>
          file.code.startsWith("IT")
        );
      } else if (activeFilterType.value === "filtroPdr") {
        filteredFiles = filteredFiles.filter(
          (file) => !file.code.startsWith("IT")
        );
      }
      if (code) {
        filteredFiles = filteredFiles.filter((item) =>
          item.code.toLowerCase().includes(code)
        );
      }
      filteredSubentro.value = filteredFiles;
      if (filtroStatoAttivo) {
        filteredSubentro.value = filteredSubentro.value.filter(
          (data) => data.stato_corrispondente !== "completamento"
        );
      }
    };
    document.addEventListener("DOMContentLoaded", function () {
      const filterButtons = document.querySelector(".filter-buttons");
      filterButtons.addEventListener("click", (event) => {
        const button = event.target;
        const filterType = button.getAttribute("data-filter");
        if (filterType) {
          applyFilter(filterType);
        }
      });
    });
    const fetchCurrentStatus = async (data) => {
      try {
        const filesResponse = data;
        const formattedFiles = filesResponse.map((file, index) => ({
          ...file,
          created_at: moment(file.data).format("YYYY-MM-DD HH:mm:ss"),
          isTimelineVisible: false,
          uniqueId: index + 1,
        }));
        Subentro.value = formattedFiles;
        formattedFiles.forEach((pratica) => {
          const timelineItemIndex = timelineData.value.findIndex(
            (item) => item.numero === pratica.cod_type_stato_pratica
          );
          if (timelineItemIndex !== -1) {
            timelineData.value[timelineItemIndex].colore = "blue";
          }
        });
      } catch (error) {
        console.error("Errore durante il recupero dei file:", error);
      } finally {
        loader.value = false;
      }
    };
    const statoToIdMap = {
      Acquisizione: 1,
      "in lavorazione": 2,
      "prima pianificazione": 3,
      sopralluogo: 4,
      preventivo: 5,
      "adempimenti ed autorizzazioni": 6,
      "seconda pianificazione": 7,
      "esecuzione intervento": 8,
      completamento: 9,
      ko: 10
    };
    const changePraticaStatus = async (pratica) => {
      service.syncPrivateByNote(pratica);

      try {
        const statoId =
          pratica.selectedStato.id ??
          pratica.selectedStato.numero ??
          statoToIdMap[pratica.selectedStato.stato];
        if (statoId !== undefined) {
          console.log("Stato selezionato:", pratica.selectedStato.stato);
        } else {
          console.error("Stato non mappato:", pratica.selectedStato.stato);
        }
      } catch (error) {
        console.error(
          "Errore durante la gestione del cambio di stato della pratica:",
          error
        );
      }
    };
    const applyCurrentFilter = () => {
      if (activeFilterType.value) {
        applyFilter(activeFilterType.value);
      } else {
        filteredSubentro.value = Subentro.value;
      }
      if (filtroStatoAttivo) {
        filteredSubentro.value = filteredSubentro.value.filter(
          (data) => data.stato_corrispondente !== "completamento"
        );
      }
    };
    const applyHistoryToPratica = (pratica, states, fallbackStatus) => {
      const activeColor = "#2196F3";
      const inactiveColor = "#607d8b";
      const errorColor = "#ff0303";

      pratica.states = states;

      const currentState = Number(
        states[0]?.cod_type_stato_pratica ?? fallbackStatus
      );

      if (Number.isNaN(currentState)) {
        return;
      }

      pratica.stato_corrispondente =
        states[0]?.stato_corrispondente ?? pratica.stato_corrispondente;
      pratica.cod_type_stato_pratica = currentState;
      pratica.coloreStatoPratica =
        currentState === 10 ? errorColor : activeColor;

      const firmatoId = idPreventivoFirmato(types_stato_pratica.value);
      timelineData.value = annidaPreventivoFirmato(ordinaStati(
        currentState === 10
          ? types_stato_pratica.value.filter((type) => type.id == 10)
          : types_stato_pratica.value.filter((type) => type.id != 10)
      ).map((timelineState) => ({
        ...timelineState,
        color: statoTimelineRaggiunto(timelineState.id, currentState, firmatoId)
          ? activeColor
          : inactiveColor,
        color_connector: statoTimelineSuperato(timelineState.id, currentState, firmatoId)
          ? activeColor
          : inactiveColor,
        ...(timelineState.id == 10
          ? {
              color: errorColor,
              color_connector: errorColor,
            }
          : {}),
      })));
    };

    const openInfoDialog = async (data) => {
      try {
        dialoginfo.value = true;
        selectedpratica.value = {
          ...data,
          privato: 1,
          id: data.id,
          clientid: data.clientid || data.client_id || data.id_cliente,
          client_id: data.clientid || data.client_id || data.id_cliente,
          nomerappresentante: data.nomerappresentante || data.NomeCliente || '',
          cognomerappresentante: data.cognomerappresentante || data.CognomeCliente || '',
          numero_telefono: data.numero_telefono || data.telefono || '',
          codiceFiscale: data.codiceFiscale || data.codice_fiscale || '',
          ragsoc: data.ragsoc || data.ragionesociale || '',
          code: data.code || data.codicepod || " - ",
          podid: data.podid,
          rappid: data.rappid,
          codecliente: data.codecliente,
          intestatario: data.intestatario,
          name: data.name,
          ragionesociale: data.ragionesociale,
          codicepod: data.codicepod
        };

        try {
          const response = await service.getPreventivoPratica(data.id, 'Subentro');
          preventivoEsistente.value = response.data;
        } catch (error) {
          preventivoEsistente.value = null;
        }

        const states = await service.getPraticaHistory(
          data.id,
          "Subentro"
        );
        applyHistoryToPratica(
          selectedpratica.value,
          states,
          data.cod_type_stato_pratica
        );
      } catch (error) {
        console.error("Errore durante il recupero dello stato della pratica:", error);
        selectedpratica.value.states = [];
      }
    };
    const inviaNota = async (rowData) => {
      try {
        service.syncPrivateByNote(rowData);

        if (rowData.selectedStato?.stato === "completamento") {
          praticaInCompletamento.value = rowData;
          dialogCompletamento.value = true;
          return; 
        }

        const preventivoOk = await preparaPreventivoFirmato({
          service,
          row: rowData,
          typeFile: "Subentro",
          toast,
          lista: Subentro.value,
        });
        if (!preventivoOk) {
          return;
        }

        const privato = rowData.privato ?? 1;
        await service.aggiornaNotePraticaVolturaESubentro(
          rowData.id,
          rowData.nota,
          rowData.selectedStato,
          privato,
          rowData.code,
          rowData.denominazione,
          "Subentro"
        );

        const states = await service.getPraticaHistory(rowData.id, "Subentro");
        applyHistoryToPratica(
          rowData,
          states,
          rowData.selectedStato?.id ?? rowData.selectedStato?.numero
        );
        rowData.nota = "";
        rowData.selectedStato = null;

      
        return true;
      } catch (error) {
        console.error("Errore durante l'aggiornamento della nota:", error);
        return false;
      }
    }


    const ricaricaDialogStato = async () => {
      if (!selectedpratica.value?.id) return;
      await openInfoDialog(selectedpratica.value);
    };

    const faseInvioStato = ref("");
    const inviaStatoAnimato = async (...argomenti) => {
      if (faseInvioStato.value === "invio") {
        return;
      }
      faseInvioStato.value = "invio";
      let ok = false;
      try {
        ok = Boolean(await inviaNota(...argomenti));
      } catch (error) {
        ok = false;
      }
      if (ok) {
        try {
          await ricaricaDialogStato();
        } catch (error) {
          console.error("Errore durante il ricaricamento della pratica:", error);
        }
      }
      faseInvioStato.value = ok ? "inviato" : "";
      if (ok) {
        setTimeout(() => {
          faseInvioStato.value = "";
        }, 1400);
      }
    };
    const handleButtonClick2 = (rappidValue) => {
      window.open(`/ask/rappresentanti/${rappidValue}/dettagli`);
    };
    const handleButtonClick3 = (clientidValue) => {
      window.open(`/ask/clienti/${clientidValue}/dettagli`);
    };
    const startEditing = (rowData) => {
      rowData.isEditing = true;
    };
    const stopEditing = async (rowData) => {
      try {
        rowData.isEditing = false;
      } catch (error) {
        console.error(
          "Errore durante l'aggiornamento di UDD e Codice Pratica:",
          error
        );
      }
    };
    const handleFileChange = async (event) => {
      const fileInput = event.target;
      const fileLabel = document.getElementById("fileLabel2");
      if (fileInput.files.length > 0) {
        const file = fileInput.files[0];
        const fileName = file.name;
        try {
          fileLabel.innerHTML = `<i class="fas fa-cloud-upload-alt"></i> ${fileName}`;
          await uploadPreventiviPratiche(file);
          showSuccessAlert.value = true;
          setTimeout(() => {
            showSuccessAlert.value = false;
            fileLabel.innerHTML = `<i class="fas fa-cloud-upload-alt"></i> Carica Preventivo`;
          }, 3000);
        } catch (error) {
          console.error("Errore durante il caricamento del file:", error);
        }
      } else {
        fileLabel.innerHTML = `<i class="fas fa-cloud-upload-alt"></i> Carica Preventivo`;
      }
    };
    const handleUploadPratiche = async (event) => {
      const fileInput = event.target;
      const fileLabel = document.getElementById("fileLabel1");
      if (fileInput.files.length > 0) {
        const file = fileInput.files[0];
        const fileName = file.name;
        try {
          fileLabel.innerHTML = `<i class="fas fa-cloud-upload-alt"></i> ${fileName}`;
          await uploadAllegatiPratiche(file);
          showSuccessAlert2.value = true;
          setTimeout(() => {
            showSuccessAlert2.value = false;
            fileLabel.innerHTML = `<i class="fas fa-cloud-upload-alt"></i> Carica Allegato`;
          }, 3000);
        } catch (error) {
          console.error("Errore durante il caricamento del file:", error);
        }
      } else {
        fileLabel.innerHTML = `<i class="fas fa-cloud-upload-alt"></i> Carica Allegato`;
      }
    };
    const uploadAllegatiPratiche = async (file) => {
      try {
        const selectedPratica = selectedpratica.value;
        if (
          !selectedPratica ||
          !selectedPratica.code ||
          !selectedPratica.id ||
          !file
        ) {
          throw new Error("File non trovato nella pratica selezionata.");
        }
        const requestData = {
          id: selectedPratica.id,
          code: selectedPratica.code,
          file: file,
        };
        const response = await service.uploadAllegatiPraticheSubentro(
          requestData
        );
        if (
          response &&
          response.message === "File caricati con successo sull'FTP"
        ) {
          console.log("Caricamento effettuato con successo:", response);
        } else {
          console.error("Errore durante il caricamento del file:", response);
          throw new Error("Errore durante il caricamento del file.");
        }
        return response;
      } catch (error) {
        console.error("Errore durante il caricamento del file:", error);
        throw error;
      }
    };
    const downloadAllegatoPratica = async (id, code) => {
      try {
        await service.downloadAllegatoPraticaSubentro(id, code);
      } catch (error) {
        document.getElementById("error-alert").style.display = "block";
        console.error("Errore durante il download del Allegato:", error);
        setTimeout(() => {
          document.getElementById("error-alert").style.display = "none";
        }, 3000);
        throw error;
      }
    };
    const chooseFile = () => {
      document.getElementById("fileInput").click();
    };
    const uploadPreventiviPratiche = async (file) => {
      try {
        const selectedPratica = selectedpratica.value;
        if (
          !selectedPratica ||
          !selectedPratica.code ||
          !selectedPratica.id ||
          !file
        ) {
          throw new Error("File non trovato nella pratica selezionata.");
        }
        const requestData = {
          id: selectedPratica.id,
          code: selectedPratica.code,
          file: file,
        };
        const response = await service.uploadPreventiviPraticheVolturaESubentro(
          requestData
        );
        if (
          response &&
          response.message === "File caricati con successo sull'FTP"
        ) {
          console.log("Caricamento effettuato con successo:", response);
        } else {
          console.error("Errore durante il caricamento del file:", response);
          throw new Error("Errore durante il caricamento del file.");
        }
        return response;
      } catch (error) {
        console.error("Errore durante il caricamento del file:", error);
        throw error;
      }
    };
    const downloadPreventivoPratica = async (code,id) => {
      try {
        await service.downloadPreventivoPraticaVolturaESubentro(code,id);
      } catch (error) {
        document.getElementById("error-alert").style.display = "block";
        console.error("Errore durante il download del preventivo:", error);
        setTimeout(() => {
          document.getElementById("error-alert").style.display = "none";
        }, 3000);
        throw error;
      }
    };
    const openFilesDialog = async (id, matrice_id) => {
      // selectedFiles.value = newFilesView.value[id] || [];
      if (matrice_id in newFilesView.value) {
        selectedFiles.value = newFilesView.value[matrice_id];
      } else {
        await getFileCaricamento(matrice_id).then(() => {
          selectedFiles.value = newFilesView.value[matrice_id];
        });
      }
      selectedMatriceId.value = matrice_id;
      filesDialogVisible.value = true;
    };
    const getFileCaricamento = async (matrice_id) => {
      loadingFilter.value = true;
      await service
        .getFileCaricamento(matrice_id)
        .then((res) => {
          newFilesView.value[matrice_id] = res.items;
        })
        .finally(() => {
          loadingFilter.value = false;
        });
    };
    const showFileUploadButton = () => {
      return true;
    };
    const aggiungiPratica = () => {
      dialogVisible.value = true;
    };
    const uddEditor = {
      template: '<InputText v-model="rowData.udd" />',
    };
    const codicePraticaEditor = {
      template: '<InputText v-model="rowData.codicePratica" />',
    };
    const aggiungiPraticaConferma = async () => {
      try {
        if (
          !nuovaPratica.value.code ||
          !nuovaPratica.value.dataDaNonEseguirePrimaDel ||
          !nuovaPratica.value.telefono ||
          !nuovaPratica.value.infoContatore
        ) {
          return;
        }
        const nuovaPraticaObj = {
          code: nuovaPratica.value.code,
          udd: nuovaPratica.value.udd,
          codicePratica: nuovaPratica.value.codicePratica,
          telefono: nuovaPratica.value.telefono,
          dataDaNonEseguirePrimaDel:
            nuovaPratica.value.dataDaNonEseguirePrimaDel,
          infoContatore: nuovaPratica.value.infoContatore,
        };
        await service.aggiungiPraticaConferma(nuovaPraticaObj);
        showSuccessAlert.value = true;
        dialogVisible.value = false;
        setTimeout(() => {
          showSuccessAlert.value = false;
        }, 3000);
      } catch (error) {
        console.error("Errore durante l'aggiunta della pratica:", error);
      }
    };
    const exportToExcel = () => {
      const array =
        selectedRows.value.length > 0
          ? [...selectedRows.value]
          : [...filteredSubentro.value];
      const data = array.map((row) => ({
        "Data Creazione": moment(row.data_creazione).format("DD/MM/Y"),
        "Ragione Sociale": row.denominazione,
        "Codice Fiscale": row.cf,
        "Partita Iva": row.piva,
        Referente: row.referente,
        Code: row.code,
        Matricola: row.matricola,
        Remi: row.CodiceRemi,
        "Tipologia uso": row.tipoFornitura,
        Telefono: row.cell,
        Toponimo: row.toponimo,
        Indirizzo: row.indirizzo,
        Civico: row.civico,
        Cap: row.cap,
        Comune: row.comune,
        Provincia: row.code_provincia,
        Istat: row.istat,
        Email: row.email,
        "Ultimo Stato": row.stato_corrispondente,
        Nota: row.nota,
        "Ultima Nota": row.states && row.states.length > 0
          ? row.states
              .sort((a, b) => new Date(b.data_nota) - new Date(a.data_nota))
              .slice(0, 1)[0]?.nota || ""
          : "",
        "Dettaglio Esito Precheck": row.precheck_description,
      }));
      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Subentro");
      XLSX.writeFile(workbook, "Subentro.xlsx");
    };
    const setActiveFilter = (filter) => {
      activeFilter.value = filter;
      applyFilter(filter);
    };
    const has_selectedRows = ref(false);


    const inSelectedRows = (data) => {
      if (data.selected) {
        selectedRows.value.push(data);
      } else {
        let index = selectedRows.value.findIndex((row) => row.id == data.id);
        if (index != -1) {
          selectedRows.value.splice(index, 1);
        }
      }
      if ( selectedRows.value.length != 0) {
        if (selectedRows.value.length < filteredSubentro.value.length) {
          has_selectedRows.value = false
        } else if(selectedRows.value.length == filteredSubentro.value.length){
          has_selectedRows.value = true
        }
      } else if ( selectedRows.value.length == 0) {
        has_selectedRows.value = false
      }
    };

    const selectAllRows = () => {
      selectedRows.value = [];
      if (!has_selectedRows.value) {
        filteredSubentro.value.forEach((el) => {
          el.selected = false;
        });
      } else {
        filteredSubentro.value.forEach((el) => {
          if (!el.selected && el.canSelect) {
            el.selected = true;
            selectedRows.value.push(el);
          }
        });
      }
    };

    const openPreventivo = () => {
      preventivoDialog.value = true;
    };

    const generaPreventivo = async () => {
      try {
        if (!importoPreventivo.value) {
          toast.add({
            severity: 'error',
            summary: 'Errore',
            detail: 'Importo preventivo non specificato',
            life: 3000
          });
          return;
        }

        preventivoData.value = {
          cod_cliente: selectedpratica.value.clientid,
          cod_pratica: selectedpratica.value.id,
          importo: Number(importoPreventivo.value),
          stato: 0,
          type_pratica: 'Subentro',
          creation_time: new Date().toISOString()
        };

        await service.salvaPreventivoPartica(preventivoData.value);

        preventivoDialog.value = false;
        importoPreventivo.value = null;

        toast.add({
          severity: 'success',
          summary: 'Successo',
          detail: 'Preventivo salvato correttamente',
          life: 3000
        });

      } catch (error) {
        toast.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Errore durante il salvataggio del preventivo',
          life: 3000
        });
        console.error("Errore durante la generazione del preventivo:", error.response?.data || error);
      }
    };

    const confermaCompletamento = async () => {
      try {
        if (!dataCompletamento.value) {
          toast.add({
            severity: 'error',
            summary: 'Errore',
            detail: 'Inserire la data di completamento',
            life: 3000
          });
          return;
        }

        const rowData = praticaInCompletamento.value;

        const dataFormattata = moment(dataCompletamento.value).format('YYYY-MM-DD');

        service.syncPrivateByNote(rowData);
        await service.completamentoDataInizio(rowData.id, rowData.code, dataFormattata);

        await service.aggiornaNotePraticaVolturaESubentro(
          rowData.id,
          rowData.nota,
          rowData.selectedStato,
          rowData.privato ?? 1,
          rowData.code,
          rowData.denominazione,
          "Subentro"
        );

        const states = await service.getPraticaHistory(rowData.id, "Subentro");
        applyHistoryToPratica(
          rowData,
          states,
          rowData.selectedStato?.id ?? rowData.selectedStato?.numero
        );
        rowData.nota = "";
        rowData.selectedStato = null;
        dialogCompletamento.value = false;
        dataCompletamento.value = null;
        praticaInCompletamento.value = null;

        toast.add({
          severity: 'success',
          summary: 'Successo',
          detail: 'Pratica completata con successo',
          life: 3000
        });

      } catch (error) {
        console.error("Errore durante il completamento della pratica:", error);
        toast.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Errore durante il completamento della pratica',
          life: 3000
        });
      }
    };
    const filenameSubentro = ref("");
    const isDownloadedFilePratica = ref(false);
    const ids_richiesta = ref([]);

    const downloadFileSubentro = async () => {
      if (!currentType.value || !selectedRows.value.length || loadingFilter.value) return;
      if (currentType.value !== 'ee') {
        toast.add({severity: 'warn', detail: 'Template gas non disponibile', life: 5000});
        return;
      }
      loadingFilter.value = true;
      const ids = selectedRows.value.map(row => row.id);
      const fd = new FormData();
      fd.append('ids', JSON.stringify(ids));
      try {
        filenameSubentro.value = await service.downloadFilePratica(fd, `s1-${currentType.value}`);
        isDownloadedFilePratica.value = true;
        selectedRows.value.forEach(row => {
          row.selected = false;
          row.canSelect = false;
        });
        selectedRows.value = [];
        has_selectedRows.value = false;
      } catch (error) {
        console.error(error);
        toast.add({severity: 'error', summary: 'Download non riuscito', detail: error.downloadMessage || 'Impossibile generare il file subentro per le pratiche selezionate', life: 5000});
        return;
      } finally {
        loadingFilter.value = false;
      }
      try {
        await Promise.all([getListSubentro(currentItem.value, [null], true), getActivePratiche()]);
      } catch (error) {
        console.error('Errore aggiornamento elenchi dopo download subentro:', error);
        toast.add({severity: 'warn', summary: 'File generato', detail: 'Il file ? stato generato, ma non ? stato possibile aggiornare gli elenchi. Ricarica la lista.', life: 5000});
      }
    };
    const getActivePratiche = async () => {
      ids_richiesta.value = [];
      await service.getPratiche()
      .then((res) => {
        res.items.forEach((pratica) => {
          if (pratica.id_richiesta) {
            ids_richiesta.value.push(pratica.id_richiesta);
          }
        });
      });
    };
    const id_pratica = ref()
    const saveIdPratica = () => {
      loadingFilter.value = true;
      if (ids_richiesta.value.includes(id_pratica.value)) {
        loadingFilter.value = false;
        toast.add({
          severity: "warn",
          summary: "Associazione non riuscita",
          detail: `ID di Richiesta già utilizzato`,
          life: 10000,
        });
        id_pratica.value = "";
        return;
      }
      let severity = "success";
      let summary = "Associazione eseguita";
      let detail = `${filenameSubentro.value} è stato associato all'id ${id_pratica.value}`;
      service.saveIdPratica(filenameSubentro.value, id_pratica.value)
      .then((res) => {
        loadingFilter.value = false;
        if (!res) {
          severity = "warn";
          summary = "Associazione non riuscita";
          detail = `${filenameSubentro.value} non è stato associato all'id ${id_pratica.value}`;
        }
        toast.add({
          severity: severity,
          summary: summary,
          detail: detail,
          life: 10000,
        });
      })
      .finally(() => {
        isDownloadedFilePratica.value = false;
      });
    };
    const resetPratica = async (data) => {
      await service.resetPratica(data.filename, data.supply_id)
      .then((res) => {
        let severity = 'danger'
        let detail = 'Errore ripristino pratica'
        if (res.items) {
          severity = 'success'
          detail = 'Pratica ripristinata correttamente'
        }
        toast.add({severity: severity, detail: detail, time: 5000})
      });
    }
    const rowClass = (data) => {
      return [{ "bg-danger": data.cod_type_stato_pratica == 10 }];
    };

    const isPrivateAutomaticallyManaged = computed(() => {
      return service.getPrivateByNoteRule(
        selectedpratica.value?.selectedStato,
        selectedpratica.value?.nota
      ).isManaged;
    });

    watch(
      [
        () => selectedpratica.value?.selectedStato?.stato,
        () => selectedpratica.value?.nota,
      ],
      () => service.syncPrivateByNote(selectedpratica.value),
      { immediate: true }
    );


    return {
      moment,
      loader,
      toast,
      dialogLoading,
      loadingFilter,
      newFilesView,
      Subentro,
      cod_pod,
      expandedRows,
      rappid,
      clientid,
      handleFileChange,
      chooseFile,
      handleButtonClick3,
      handleButtonClick2,
      timelineData,
      startEditing,
      stopEditing,
      fetchCurrentStatus,
      selectedpratica,
      openInfoDialog,
      dialoginfo,
      changePraticaStatus,
      statiDisponibili,
      timelineKey,
      currentRecordIndex,
      inviaNota,
      faseInvioStato,
      inviaStatoAnimato,
      statiMassivi,
      impostaFilePreventivoFirmato,
      showFileUploadButton,
      uploadPreventiviPratiche,
      showSuccessAlert,
      showSuccessAlert2,
      dialogVisible,
      nuovaPratica,
      aggiungiPratica,
      aggiungiPraticaConferma,
      defaultDate,
      uddEditor,
      codicePraticaEditor,
      downloadPreventivoPratica,
      handleUploadPratiche,
      downloadAllegatoPratica,
      filteredSubentro,
      applyFilter,
      showFilterButton,
      rimuoviFiltroStato,
      filtroStatoAttivo,
      isActive,
      filesDialogVisible,
      selectedFiles,
      openFilesDialog,
      downloadPdf,
      downloadZip,
      selectedMatriceId,
      exportToExcel,
      searchCode,
      filterByCode,
      activeFilterType,
      saveEdit,
      searchTerm,
      selectedRows,
      massiveSelectedStatus,
      applyMassiveStatusChange,
      isVisibleBtnDownloadSubentro,
      user,
      filters,
      types_stato_pratica,
      activeFilter,
      setActiveFilter,
      getListSubentro,
      types_pp,
      currentData,
      inSelectedRows,
      has_selectedRows,
      selectAllRows,
      newStati,
      statiSoloPreventivo,
      vedeSoloPreventivo,
      preventivoDialog,
      importoPreventivo,
      preventivoData,
      generaPreventivo,
      openPreventivo,
      preventivoEsistente,
      dialogCompletamento,
      dataCompletamento,
      confermaCompletamento,
      downloadFileSubentro,
      filenameSubentro,
      isDownloadedFilePratica,
      id_pratica,
      saveIdPratica,
      resetPratica,
      searchedStatus,
      setSearchedStatus,
      isVisibleBtnSearchedStatus,
      rowClass,
      isPrivateAutomaticallyManaged,
      currentType,
    };
  },
};
</script>
<style scoped>
.active-button {
  background-color: #007bff;
  color: white;
}
#error-alert {
  display: none;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #ffcccc;
  padding: 10px 20px;
  border-radius: 5px;
  font-size: 16px;
  color: #ff0000;
  z-index: 1000;
}
.p-grid .p-col-12 {
  margin-bottom: 1rem;
}
.styled-button-Nota {
  background-color: #3498db;
  border: none;
  color: white;
  padding: 14px 24px;
  text-decoration: none;
  font-size: 13px;
  cursor: pointer;
  border-radius: 8px;
  margin-right: 10px;
  margin-bottom: 10px;
  align-self: stretch;
}
.styled-button-Nota:hover {
  background-color: #2980b9;
}
form {
  display: flex;
  flex-direction: column;
}
.form-container {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
.button-group {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 10px;
}
.custom-file-upload {
  display: inline-block;
  padding: 12px 22px;
  font-size: 13px;
  cursor: pointer;
  background-color: #3498db;
  color: #fff;
  border-radius: 8px;
  border: none;
  transition: background-color 0.3s ease;
  margin-right: 10px;
  margin-bottom: 10px;
  text-align: center;
  width: 120px;
}
.custom-file-download {
  display: inline-block;
  padding: 14px 24px;
  font-size: 13px;
  cursor: pointer;
  background-color: #3498db;
  color: #fff;
  border-radius: 8px;
  border: none;
  transition: background-color 0.3s ease;
  margin-right: 10px;
  margin-bottom: 10px;
  text-align: center;
  width: 120px;
}
.custom-file-upload:hover {
  background-color: #2980b9;
}
input[type="file"] {
  display: none;
}
.custom-alert {
  background-color: #4caf50;
  color: white;
  padding: 15px;
  border-radius: 5px;
  position: fixed;
  z-index: 9999;
  left: 50%;
  top: 40%;
  transform: translate(-50%, -50%);
  animation: fadeInOut 2s forwards;
}
@keyframes fadeInOut {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.custom-alert:hover,
.custom-alert:focus {
  opacity: 1;
}
.custom-alert:hover,
.custom-alert:focus {
  animation: fadeOut 2s ease-in-out forwards;
}
.filter-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 10px;
  margin-left: 10px;
  align-items: center;
}
.filter-buttons,
.filter-actions {
  display: flex;
  gap: 10px;
}
.active-button {
  background-color: white !important;
  color: blue !important;
}
.button-like:hover {
  text-decoration: none;
  color: navy;
}
.table-container {
  margin-top: 20px;
}
.popup {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  width: auto;
  max-width: 100%;
  max-height: 90vh;
  overflow: auto;
}
.popup-close {
  position: absolute;
  top: 3px;
  right: 5px;
  width: 20px;
  height: 20px;
  border: none;
  background: transparent;
  color: black;
  font-size: 18px;
  font-weight: bold;
  line-height: 1;
  cursor: pointer;
  outline: none;
}
.nota-container {
  display: flex;
  align-items: center;
}
.nota-container input {
  flex: 1;
  margin-right: 5px;
}
.popup-close:hover {
  color: darkgray;
}
.custom-dialog .dialog-content {
  display: flex;
  align-items: flex-start;
  gap: 24px;
}
.custom-dialog .dialog-loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.custom-dialog .timeline-container {
  flex: 0 0 280px;
  overflow: visible;
  margin: 0;
  padding: 4px 16px 4px 4px;
  border-right: 1px solid #e6ebf1;
}
.timeline {
  display: flex;
  flex-direction: row;
  white-space: nowrap;
  overflow-x: auto;
}
.timeline-item {
  position: relative;
  margin-right: 20px;
}
.timeline-item span {
  position: relative;
  top: -17px;
}
.pallino {
  position: relative;
  left: -28px;
}
.blue {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: blue;
}
.default {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border-color: blue;
  border-width: 15px;
  background-color: gray;
}
.data-tables-container {
  flex: 1;
  overflow-x: auto;
}
.file-link {
  color: #3498db;
}
.file-link:hover {
  cursor: pointer;
}

.styled-button-Nota-Preventivo {
  background-color: #269a4d;
  border: none;
  color: white;
  padding: 12px 18px;
  text-decoration: none;
  font-size: 13px;
  cursor: pointer;
  border-radius: 8px;
  
}
.cliente-info {
  background-color: #f8f9fa;
  padding: 15px;
  border-radius: 8px;
  margin-top: 10px;
}

.cliente-info p {
  margin: 8px 0;
  line-height: 1.4;
}

.cliente-info b {
  color: #495057;
  min-width: 140px;
  display: inline-block;
}

.preventivo-esistente {
  background-color: #269a4d;
  padding: 15px;
  border-radius: 8px;
  margin-top: 10px;
  text-align: center;
  font-size: 16px;
}

.preventivo-esistente p {
  margin: 0;
  color: #f0f0f0;
}



.custom-dialog :deep(.p-dialog-content) {
  padding: 0.75rem 1rem;
}

.stato-pannello {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}

.stato-scheda {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
  padding: 8px 12px;
  background: #f4f7fb;
  border: 1px solid #e3eaf2;
  border-radius: 8px;
}

.stato-scheda__voce {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.stato-scheda__voce span {
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.stato-scheda__voce strong {
  color: #0f172a;
  font-size: 14px;
  line-height: 1.35;
  overflow-wrap: anywhere;
}

.stato-blocco {
  padding: 10px 12px;
  border: 1px solid #e6ebf1;
  border-radius: 8px;
  background: #fff;
}

.stato-blocco h3 {
  margin: 0 0 8px;
  color: #0f3d6e;
  font-size: 14px;
}

.stato-campo {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 8px;
}

.stato-campo > span,
.stato-privato {
  color: #475569;
  font-size: 13px;
  font-weight: 600;
}

.stato-campo :deep(.p-dropdown) {
  width: 100%;
}

.stato-privato {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.stato-nota {
  width: 100%;
  min-height: 44px;
  height: 44px;
  resize: vertical;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  padding: 6px 10px;
  font: inherit;
  color: #0f172a;
  box-sizing: border-box;
}

.stato-modulo .styled-button-Nota {
  align-self: flex-start;
  margin: 0;
  min-width: 96px;
  padding: 8px 16px;
}

.stato-file {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.stato-file__riga {
  display: grid;
  grid-template-columns: 150px minmax(0, 1fr);
  align-items: center;
  gap: 8px;
  padding: 4px 0;
  border-bottom: 1px solid #eef2f6;
}

.stato-file__riga:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.stato-file__nome {
  color: #475569;
  font-size: 13px;
  font-weight: 600;
}

.stato-file .button-group {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: 0;
}

.stato-file .custom-file-upload,
.stato-file .custom-file-download {
  width: auto;
  min-width: 148px;
  min-height: 32px;
  margin: 0 8px 0 0;
  padding: 0 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  box-sizing: border-box;
}

.stato-importo .styled-button-Nota-Preventivo {
  padding: 8px 14px;
  margin: 0;
}

.stato-storico :deep(.p-datatable .p-datatable-thead > tr > th),
.stato-storico :deep(.p-datatable .p-datatable-tbody > tr > td) {
  padding: 0.35rem 0.6rem;
}

.stato-storico :deep(.p-paginator) {
  padding: 0.25rem 0 0;
}

.stato-importo .preventivo-esistente {
  margin-top: 0;
  padding: 8px 12px;
  font-size: 14px;
}

.stato-importo .preventivo-esistente p {
  margin: 0;
}

@media (max-width: 900px) {
  .custom-dialog.stato-dialog .dialog-content {
    flex-direction: column;
  }

  .custom-dialog.stato-dialog .timeline-container {
    flex: none;
    width: 100%;
    overflow: visible;
    border-right: none;
    border-bottom: 1px solid #e6ebf1;
  }

  .stato-scheda,
  .stato-file__riga {
    grid-template-columns: 1fr;
  }
}

.timeline-container :deep(.p-timeline-event-opposite) {
  display: none;
  flex: none;
  padding: 0;
}

.timeline-container :deep(.p-timeline-event-content) {
  padding: 0 0 12px 10px;
  line-height: 1.35;
}

.timeline-container :deep(.p-timeline-event-separator) {
  flex: none;
}

.stato-punto {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #cbd5e1;
  box-shadow: 0 0 0 3px #fff, 0 0 0 5px #cbd5e1;
}

.stato-punto--attivo {
  background: #2196f3;
  box-shadow: 0 0 0 3px #fff, 0 0 0 5px #2196f3;
}

.stato-passo__nome {
  display: block;
  margin-top: 1px;
  color: #475569;
  font-size: 14px;
}

.stato-passo__nome--attivo {
  color: #1565c0;
  font-weight: 700;
}


.styled-button-Nota--invio,
.styled-button-Nota--ok {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.styled-button-Nota:disabled {
  opacity: 1;
  cursor: default;
}

.styled-button-Nota--ok {
  background-color: #269a4d;
}

.invio-stato__spinner {
  width: 14px;
  height: 14px;
  margin-right: 8px;
  border: 2px solid rgba(255, 255, 255, 0.45);
  border-top-color: #fff;
  border-radius: 50%;
  animation: invio-stato-giro 0.7s linear infinite;
}

.invio-stato__check {
  display: inline-block;
  margin-right: 6px;
  font-weight: 700;
  animation: invio-stato-pop 0.35s ease;
}

@keyframes invio-stato-giro {
  to { transform: rotate(360deg); }
}

@keyframes invio-stato-pop {
  0% { transform: scale(0.4); opacity: 0; }
  70% { transform: scale(1.15); }
  100% { transform: scale(1); opacity: 1; }
}

</style>
